import { Typography, Icon, Tooltip } from "@material-ui/core";
import moment from "moment";

function TypeComponent(props) {
	const item = props.item;
	const smallScreen = props.smallScreen;

	// Badge List
	const bookBadge = item.booknow || item.bidnow;
	const testBadge = item.test;
	const hasContact = item.contacted;
	const isCallEnded = item.contacted_end && item.contacted_end > item.contacted;
	const isEmailSent = item.email_sent;
	const isEmailReplied = item.email_replied;
	const isVerified = item.verified;
	const isCovered = item.coveredBy;
	const isPhoneUnreachable = item.n_contacts >= 2;
	const isEmailUnreachable = item.n_contacts >= 3;

	return (
		<div className="flex items-center">
			{bookBadge ? (
				<div className={"flex flex-row h-18 rounded-4 border-1 border-purple"}>
					<div className={`min-w-16 h-16 justify-center` + (smallScreen ? " bg-transparent " : " bg-purple-800 ")}>
						<Icon className={`font-500 text-12 p-2 ` + (smallScreen ? " text-purple-800 " : " text-white ")}>
							flash_on
						</Icon>
					</div>
					{!smallScreen && (
						<Typography className={"font-500 px-2 text-purple-800 text-12 ml:text-11"}>{"Book"}</Typography>
					)}
				</div>
			) : null}
			{testBadge ? (
				<div className={"flex flex-row h-18 rounded-4 border-1 border-blue ml-2"}>
					<div
						className={`min-w-16 h-16 justify-center` + (smallScreen || bookBadge ? " bg-transparent " : " bg-blue ")}
					>
						<Icon className={`font-500 text-13 p-1.5 ` + (smallScreen || bookBadge ? " text-blue " : " text-white ")}>
							star
						</Icon>
					</div>
					{!(smallScreen || bookBadge) && (
						<Typography className={"font-500 px-2 pt-1 text-blue text-12 ml:text-10"}>{"Test"}</Typography>
					)}
				</div>
			) : null}

			{isCovered ? (
				<div className={`flex items-center ml-2`}>
					<Tooltip title={`Covered by: ${item.coveredBy}`}>
						<Icon className={`text-16 text-blue-800`}>verified</Icon>
					</Tooltip>
				</div>
			) : isVerified ? (
				<div className={`flex items-center ml-2`}>
					<Tooltip title={`Verified by: ${item.verifiedBy || "Unknown"}`}>
						<Icon className={`text-16 text-green-400`}>verified</Icon>
					</Tooltip>
				</div>
			) : null}
			{(hasContact || isEmailSent) && (
				<div className={`flex items-center ml-2`}>
					<Tooltip
						title={
							(isEmailReplied
								? `Replied: ${moment(item.email_replied).format("DD/MM/YYYY HH:mm:ss")}`
								: `Sent: ${moment(item.email_sent).format("DD/MM/YYYY HH:mm:ss")}`) +
							(item.n_contacts ? ` (${item.n_contacts} attempts)` : "") +
							(item.reason ? ` - ${item.reason}` : "")
						}
						placement="top"
					>
						<span className="flex items-center">
							{isEmailSent ? (
								<Icon
									className={`text-16 ml-1 ${
										isEmailReplied ? "text-orange-800" : isEmailUnreachable ? "text-grey-600" : "text-red-400"
									}`}
								>
									{isEmailReplied ? "mark_email_read" : isEmailUnreachable ? "unsubscribe" : "email"}
								</Icon>
							) : (
								""
							)}
						</span>
					</Tooltip>
					<Tooltip
						title={
							(isCallEnded
								? `Ended: ${moment(item.contacted_end).format("DD/MM/YYYY HH:mm:ss")}`
								: hasContact
								? `Called: ${moment(item.contacted).format("DD/MM/YYYY HH:mm:ss")}`
								: "") +
							(item.n_contacts ? ` (${item.n_contacts} attempts)` : "") +
							(item.reason ? ` - ${item.reason}` : "")
						}
					>
						<span className="flex items-center">
							{hasContact ? (
								<Icon
									className={`text-16 ${
										isCallEnded ? "text-orange-800" : isPhoneUnreachable ? "text-grey-600" : "text-red-400"
									}`}
								>
									{isCallEnded ? "phone_disabled" : isPhoneUnreachable ? "phone_locked" : "phone_in_talk"}
								</Icon>
							) : (
								""
							)}
						</span>
					</Tooltip>
				</div>
			)}
		</div>
	);
}

export default TypeComponent;
